import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Pagination } from 'antd';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        return (
            <div className={css.Pagination}>
                {
                    this.modulesState.total > this.modulesState.pageSize && 
                    <Pagination pageSize={this.modulesState.pageSize} size="small" showQuickJumper={true} defaultCurrent={this.modulesState.pageNum} total={this.modulesState.total} onChange={this.onChange} />
                }
            </div>
        );
    }
    /** 改变页数 */
    private onChange(pageNumber: number) {
        ModulesAction.setPage(pageNumber);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/UI.AppPages.tsx